import { createContext, use } from "react";

/** Opens a stored file in a panel over the page. Provided by FilePreviewProvider. */
export const FilePreviewContext = createContext<(path: string, title?: string) => void>(() => {});

export function useFilePreview(): (path: string, title?: string) => void {
  return use(FilePreviewContext);
}
